import React from 'react';
import { Badge } from '../../../../../components/ui/badge';
import { CheckCircle, Clock, AlertCircle, XCircle, Mail } from 'lucide-react';

export const StatusBadge = ({ status, type = "response", className = "" }) => {
  const getStatusConfig = () => {
    switch (type) {
      case "response":
        switch (status) {
          case "responded":
          case "received":
            return {
              icon: CheckCircle,
              text: "Received",
              className: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300 border border-green-200 dark:border-green-700"
            };
          case "pending":
          case "waiting":
            return {
              icon: Clock,
              text: "Waiting",
              className: "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300 border border-amber-200 dark:border-amber-700"
            };
          case "invited":
            return {
              icon: Mail,
              text: "Invited",
              className: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300 border border-blue-200 dark:border-blue-700"
            };
          case "declined":
            return {
              icon: XCircle,
              text: "Declined",
              className: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300 border border-red-200 dark:border-red-700"
            };
          default:
            return {
              icon: AlertCircle,
              text: "Unknown",
              className: "bg-slate-100 text-slate-800 dark:bg-slate-900/30 dark:text-slate-300 border border-slate-200 dark:border-slate-700"
            };
        }
      case "favorite":
        return {
          icon: null,
          text: "⭐ Favorite",
          className: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300 border border-yellow-200 dark:border-yellow-700"
        };
      case "language":
        return {
          icon: null,
          text: status?.toUpperCase() || "EN",
          className: "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300 border border-purple-200 dark:border-purple-700"
        };
      default:
        return {
          icon: null,
          text: status,
          className: "bg-slate-100 text-slate-800 dark:bg-slate-900/30 dark:text-slate-300 border border-slate-200 dark:border-slate-700"
        };
    }
  };

  const config = getStatusConfig();
  const Icon = config.icon;

  return (
    <Badge className={`${config.className} ${className}`}>
      {Icon && <Icon className="h-3 w-3 mr-1" />}
      {config.text}
    </Badge>
  );
}; 